// Shared literal data for server-rendered startup markup and the browser buffer.
// Keep this entrypoint free of use-client directives and browser dependencies.

export const EARLY_ERROR_BUFFER_KEY = "__atriamEarlyErrors" as const;

/**
 * Inline-script source for the early-error shim. Exported as a string so
 * the Next.js layout can render it via `<script nonce={nonce} dangerouslySetInnerHTML>`,
 * which is the only CSP-compatible way to inject a script before hydration
 * when the policy is nonce-based.
 *
 * Keep this minimal: it runs on every page load BEFORE Next.js's bundle.
 * No dependencies, no async, no try/catch around the listeners themselves
 * (we want the original error to bubble to the browser console as well).
 */
export const EARLY_ERROR_SHIM_SOURCE = `
(function(){
  if (typeof window === 'undefined') return;
  if (window.${EARLY_ERROR_BUFFER_KEY}) return;
  var buf = (window.${EARLY_ERROR_BUFFER_KEY} = []);
  var MAX = 50;
  function push(entry){ if (buf.length < MAX) buf.push(entry); }
  window.addEventListener('error', function(e){
    // Resource-loading failures (img/script/link 404s) fire 'error' events
    // whose target is the failed DOM element (not the window). Skip them:
    // they're third-party network noise (PostHog toolbar.css, an analytics
    // pixel) and they produce "unknown error" records with every detail field
    // blank, which buries real script errors in the issue list. Use
    // instanceof Element rather than (target !== window) because dispatched
    // ErrorEvents in jsdom and some real browsers leave target null/window.
    if (e && e.target && typeof Element !== 'undefined' && e.target instanceof Element) return;
    var msg = (e && e.message) || (e && e.error && e.error.message);
    if (!msg) return;
    push({
      t: Date.now(),
      kind: 'error',
      message: msg,
      source: e && e.filename || undefined,
      line: e && e.lineno || undefined,
      col: e && e.colno || undefined,
      stack: e && e.error && e.error.stack || undefined,
    });
  }, true);
  window.addEventListener('unhandledrejection', function(e){
    var r = e && e.reason;
    var msg = (r && (r.message || String(r))) || 'unhandled rejection';
    push({
      t: Date.now(),
      kind: 'rejection',
      message: msg,
      stack: r && r.stack || undefined,
    });
  }, true);
})();
`.trim();
